import React, { useState } from 'react';
import moment from 'moment';
import { get, size, map, includes } from 'lodash';
import { object, bool, string, func, array } from 'prop-types';
import styled from 'styled-components';
import { withApollo } from 'react-apollo';
import { Row, Column, Title, Subtitle, Card, Text, AppIcon, StatusTag, Number, ConfirmFooterButtons, Radio, Drawer, HasPermissions } from '../../common';
import { _get, productPickingType, getStatusCode } from '../../../utils/misc';
import { formatProductQuantity } from '../../pdf-commons/utils';
import REFUSE_REQUEST from '../../../queries/REFUSE_REQUEST';
import ModifyProduct from './ModifyProduct';

const pendingPickingValues = getStatusCode('Pendiente picking');
const enPickingValues = getStatusCode('En picking');

const Image = styled.img`
  width: auto;
  height: fit-content;
  max-height: 55px;
`;

const OrderProductDetail = ({ idOrder, data, items, pickingTime, withPicking, pickingStatus, onClose, client, session, ...props }) => {
    console.log("pickingStatus",pickingStatus)
    const ean = get(data, 'picking.ean', get(data, 'ean'));
    const statusItem = String(get(data, 'picking.statusCode', get(data, 'statusCode', null)));
    const [refuseRequest, setRefuseRequest] = useState(false);
    const [refuseError, setRefuseError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resetRadio, setResetRadio] = useState(false);
    const [opened, setOpened] = useState(false);
    const outStockStatuses = ['OUT_STOCK', 'OUT_STOCK_ACCEPTED', 'UNPICK_ADDED_BY_CLIENT', 'UNPICK_BY_STORE', undefined];
    const isOutStock = includes(outStockStatuses, get(data, 'status', get(data, 'picking.status')));
    const renderRefuseRequestStatus = () => {
        const label = 'Faltante';
        if (resetRadio) return null;
        if (isOutStock) return <Text text={label} />;
        return <Radio label={label} onChange={setRefuseRequest} isOrderProductDetail />;
    };
    const onRefuseRequest = async () => {
        if (!statusItem) return null;
        setLoading(true);
        const { data } = await client.mutate({
            mutation: REFUSE_REQUEST,
            variables: { idOrder, ean, statusItem }
        });
        const status = get(data, 'refuseRequest.status', '500');
        if (status === '500') {
            setResetRadio(true);
            setRefuseRequest(false);
            setRefuseError(true);
            setLoading(false);
            setTimeout(() => setResetRadio(false), 20);
            return;
        }
        setTimeout(async () => {
            console.log('refetching order queries');
            await client.reFetchObservableQueries();
            setRefuseRequest(false);
        }, 3000);
    };

    const renderRefuseMessage = () => {
        if (refuseError) {
            return (
                <>
                    <Text italic text='“No es posible' color='#db5959' />
                    <Text italic text='&nbsp;cambiar el estado' strong color='#db5959' />
                    <Text italic text='&nbsp;de este producto a' color='#db5959' />
                    <Text italic text='&nbsp;faltante. La orden no debe quedar sin productos pickeados.' strong color='#db5959' />
                </>
            );
        }
        return (
            <>
                <Text italic text='“Si cambias el estado de un producto,' />
                <Text italic semibold text='&nbsp;luego no se podrá volver a editar.“' />
            </>
        );
    };

    const productInfoBox = (item, isChildren) => {
        const unitMultiplier = get(item, 'unitMultiplier', 0);
        const quantity = get(item, 'quantity', 0);
        const requestedQuantity = quantity * parseFloat(unitMultiplier);
        const sellingPrice = get(item, 'sellingPrice', 0);
        const unit = get(item, 'unit', '');
        const isUpselling = get(item, 'isUpselling') ? 'Si' : 'No';

        return (
            <Row>
                <Column noFlex width={120} center>
                    <Image src={get(item, 'imageUrl', '')} />
                </Column>
                <Column flex='2'>
                    <Row align='center' mB={10} mR={10}>
                        <Column flex={4}>
                            <Title text={get(item, 'name', '')} />
                        </Column>
                        <HasPermissions to={['order-detail-page:modify-product']}>
                            {includes(['1', '2', '20'], pickingStatus) && (productPickingType(get(item, 'status', get(item, 'picking.status', 'default'))) !== 'removed') &&
                                <Column align='flex-end'>
                                    <AppIcon name='ic-edit' size='12' style={{ cursor: 'pointer' }} onClick={() => setOpened(!opened)} />
                                </Column>
                            }
                        </HasPermissions>
                    </Row>
                    <Row style={{ marginTop: '5px' }}>
                        <table style={{ width: '100%' }}>
                            <tbody>
                                <tr>
                                    <td><Text text='Marca' semibold /></td>
                                    <td><Text text={get(item, 'brandName', '')} /></td>
                                </tr>
                                <tr>
                                    <td><Text text='EAN' semibold /></td>
                                    <td><Text text={get(item, 'picking.ean', get(item, 'ean', '0'))} /></td>
                                </tr>
                                <tr>
                                    <td><Text text='SKU' semibold /></td>
                                    <td><Text text={get(item, 'refId', 0)} /></td>
                                </tr>
                                { !isChildren && (
                                    <tr>
                                        <td><Text text='Cantidad' semibold /></td>
                                     
                                        {(pendingPickingValues.includes(String(pickingStatus)) || enPickingValues.includes(String(pickingStatus))) ?
                                            <HasPermissions to={['order-detail-page:view-quantity']} otherwise="-">
                                                <td><Text text={`${unit === 'kg' ? requestedQuantity.toFixed(3).replace('.', ',') : requestedQuantity} ${unit}`} /></td>
                                            </HasPermissions>
                                        :
                                            <td><Text text={`${unit === 'kg' ? requestedQuantity.toFixed(3).replace('.', ',') : requestedQuantity} ${unit}`} /></td>
                                        }
                                        
                                    </tr>
                                ) }
                                <tr>
                                    <td><Text text='Precio' semibold /></td>
                                    <td>
                                        <Row align='center'>
                                            <Text text={<Number value={sellingPrice / unitMultiplier} />} />
                                            { (size(get(item, 'priceTags', 0)) > 0) && <Subtitle color='#666666' style={{ marginLeft: 5 }} deleted text={<Number value={get(item, 'listPrice', 0)} />} /> }
                                        </Row>
                                    </td>
                                </tr>
                                { !isChildren && (
                                    <tr>
                                        <td><Text text='Precio total solicitado' semibold /></td>
                                        <td><Text text={<Number value={sellingPrice * (isChildren ? 1 : quantity)} />} /></td>
                                    </tr>
                                ) }
                                <tr>
                                    <td><Text text='Agregado upselling offline' semibold /></td>
                                    <td><Text text={isUpselling} /></td>
                                </tr>
                                { includes(['4', '9'], pickingStatus) && !isChildren && (
                                    <tr>
                                        <td><Text text='Estado total del producto' semibold /></td>
                                        <td>
                                            { renderRefuseRequestStatus() }
                                        </td>
                                    </tr>
                                ) }
                            </tbody>
                        </table>
                        { (refuseRequest || refuseError) && !isChildren && (
                            <div style={{ marginTop: '5px' }}>
                                { renderRefuseMessage() }
                            </div>
                        ) }
                    </Row>
                </Column>
            </Row>
        );
    };

    const pickingDataBox = ({ picking, pickingQuantity, sellingPrice, unitMultiplier, unit, ...props }, isChildren) => (
        <Row>
            <Column>
                <Row align='center' mB={10}>
                    <Column direction='row' align='center'>
                        <Title text='Picking' />
                    </Column>
                    <Column align='flex-end'>
                        { get(picking, 'unpackaged') && <StatusTag fit status={`order_detail.item.picking.status.loose`} tagType='loose' /> }
                    </Column>
                </Row>
                <Row>
                    <Column noFlex width={140}>
                        <Subtitle semibold text='Fecha' />
                        <Subtitle semibold text='Cantidad' />
                        <Subtitle semibold noWrap text='Precio total pickeado' />
                        <Subtitle semibold text='Picking manual' />
                    </Column>
                    <Column flex='2'>
                        <Text size={12} lineHeight={1.67} text={`${moment(pickingTime.init).format('DD/MM/YYYY - h:mm')} hrs`} />
                        <Text size={12} lineHeight={1.67} text={formatProductQuantity(get(picking, 'pickingQuantity', pickingQuantity), unit)} />
                        <Text
                            size={12}
                            lineHeight={1.67}
                            text={<Number value={(get(picking, 'pickingQuantity', pickingQuantity) * sellingPrice / get(picking, 'unitMultiplier', unitMultiplier))} />}
                        />
                        <Text size={12} lineHeight={1.67} text={get(picking, 'manualPicking') ? 'Si' : 'No'} />
                    </Column>
                </Row>
            </Column>
        </Row>
    );

    const pickingBox = (data) => {
        if (includes(outStockStatuses, get(data, 'picking.status')) || ['41', '21'].includes(pickingStatus) || !withPicking) return null;
        if (size(get(data, 'picking.substitution', [])) <= 0) {
            return (
                <Card
                    top='10'
                    bordered
                    bodyChildren={() => pickingDataBox(data)}
                />
            );
        }
        return (
            <>
                <Row mT={11}>
                    <AppIcon name='ic-replace' size='22' style={{ position: 'relative', left: '15px' }} />
                </Row>
                { map(get(data, 'picking.substitution', []), (item, index) => (
                    <Column key={`substitute-detail-${index}`} style={{ border: '1px solid #eaeaea', borderRadius: '3px', padding: '13px' }} mY={10}>
                        <Row>
                            <Column justify='flex-start'>
                                <Title text='Resultado de picking' />
                            </Column>
                            <Column align='flex-end' justify='flex-start'>
                                { get(item, 'unpackaged') && <StatusTag fit status={`order_detail.item.picking.status.loose`} tagType='loose' /> }
                            </Column>
                        </Row>
                        { productInfoBox(item, true) }
                        { pickingDataBox(item, true) }
                    </Column>
                ))}
            </>
        );
    };

    return (
        <div style={{ width: '100%', maxHeight: 'calc(100% - 120px)', overflowY: 'auto' }}>
            <Row style={{ border: '1px solid #eaeaea', borderRadius: '3px', padding: '13px' }}>
                { productInfoBox(data, false) }
            </Row>
            <Card
                top='20'
                bordered
                noHeaderDivider
                leftHeader={() => (<Title text='Observación del cliente' />)}
                bodyChildren={() => (
                    <Row>
                        <Column flex='1'>
                            <Subtitle semibold text='Observación' />
                        </Column>
                        <Column flex='3'>
                            <Subtitle text={_get(data, 'customerNotes', 'Sin observación')} />
                        </Column>
                    </Row>
                )}
            />
            { pickingBox(data) }
            { !isOutStock && <ConfirmFooterButtons confirmDisabled={!refuseRequest} onCancel={onClose} onConfirm={onRefuseRequest} loading={loading} /> }
            <Drawer
                visible={opened}
                onClose={() => setOpened(false)}
                minWidth='311px'
            >
                <ModifyProduct item={data} idOrder={idOrder} session={session} onClose={() => setOpened(!opened)} />
            </Drawer>
        </div>
    );
};

OrderProductDetail.propTypes = {
    idOrder: string,
    data: object,
    items: array,
    client: object,
    pickingTime: object,
    withPicking: bool,
    pickingStatus: string,
    onClose: func,
    session: object
};

OrderProductDetail.defaultProps = {
    onClose: () => {}
};

export default withApollo(OrderProductDetail);
